import React from "react";
import vision from '../Assets/vision.png'

const Vision: React.FC = () => {
    return (
        <div className="flex flex-row px-3 md:px-40 pt-20 gap-10">
            <div className="w-50 hidden md:block"><img src={vision} alt="our vision" width='70%' /></div>
            <div className="flex flex-col w-50 justify-center">
                <h3 className="text-[18px] md:text-[29px] font-bold text-center">Our Vision</h3>
                <p className="text-[16px] md:text-[20px] text-justify">To create a seamless and equitable legal system accessible to all, regardless of location or circumstance.</p>
            </div>
        </div>
    )
}
export default Vision